const StaffDashboard = () => {
  return (
    <div>
      <p>This is the staff dashboard</p>
    </div>
  );
};

export default StaffDashboard;
